/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT } from '../../../styles/colors/colors';
import { EmbersMenu } from '../../../menu/menu';
export var StyledMenu = styled(EmbersMenu)({
  '.MuiMenuItem-root': {
    color: PROMETHEAN_TEXT,
    '.MuiListItemIcon-root': {
      color: PROMETHEAN_TEXT
    }
  }
});